import { Component } from '@angular/core';

@Component({
  selector: 'app-hyginestaft-link',
  templateUrl: './hyginestaft-link.component.html',
  styleUrls: ['./hyginestaft-link.component.scss']
})
export class HyginestaftLinkComponent {

}
